import { render, staticRenderFns } from "./UipLine.vue?vue&type=template&id=c540796c&scoped=true"
import script from "./UipLine.vue?vue&type=script&lang=js"
export * from "./UipLine.vue?vue&type=script&lang=js"
import style0 from "./UipLine.vue?vue&type=style&index=0&id=c540796c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c540796c",
  null
  
)

export default component.exports